module.exports = __webpack_public_path__ + "media/assets/staffs/mufan_teng-cc640ccd327f66033ebc3c576cdf76b0.jpg";